import React from 'react';

const CurvyArrowFaq: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg {...props} width="304" height="173" viewBox="0 0 304 173" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0 0C2.85416 5.14736 5.60205 9.9734 8.52285 14.9602C34.4849 58.9071 65.7121 102.589 110.845 127.668C155.936 153.008 209.382 154.688 260.263 153.16C264.696 153.015 268.948 152.845 273.299 152.647L273.228 138.033L303.972 154.184L273.398 172.761L273.326 158.25C269.014 158.375 264.793 158.472 260.394 158.545C209.25 159.238 154.9 156.677 109.447 130.134C64.0059 103.848 33.5393 59.4738 8.27709 15.1013C5.437 10.0653 2.77116 5.19252 0 0Z" fill="#79A5F8"/>
</svg>

);

export default CurvyArrowFaq;
